import React from 'react';
import { Card } from '../../../../../../components/Card/Card';
import { t } from '../../../../../../locales/translate';
import { useSuspenseQuery } from '@apollo/client';
import { graphql } from '../../../../../../generated';
import { Icon } from '../../../../../../components/Icon/Icon';
import { useModalPresenter } from '../../../../../../components/Modal/PresentedModal';
import { EditPassbook } from './edit_passbook';
import { KeyValueTable } from '../../../../../../components/KeyValueTable/KeyValueTable';
import { withSuspendedCard } from '../../../../../../util/suspense';
import { runPassbookPreviewExport } from '../../../../../../model/exports';

interface Props {
  productId: string;
}

const PASSBOOK_CONFIG = graphql(`
  query PassbookConfig($id: ID!) {
    event(id: $id) {
      id
      permissions {
        id
        updatePassbookConfig
      }
      passbookConfig {
        id
        enabled
      }
    }
  }
`);

function Passbook$({ productId }: Props): JSX.Element {
  const { data } = useSuspenseQuery(PASSBOOK_CONFIG, { variables: { id: productId } });
  const modal = useModalPresenter();
  const config = data.event.passbookConfig;
  return (
    <Card
      title={t.page.event.design.passbook.title}
      actions={<Icon name="edit" onClick={() => modal.present(EditPassbook, { productId })} />}
    >
      <KeyValueTable
        items={[
          {
            key: t.page.event.design.passbook.enabled,
            value: config.enabled
              ? t.page.event.design.passbook.enabledTrue
              : t.page.event.design.passbook.enabledFalse,
          },
          config.enabled && {
            key: t.page.event.design.passbook.preview,
            value: <Icon name="ticket" onClick={() => runPassbookPreviewExport({ productId })} />,
          },
        ]}
      />
    </Card>
  );
}

export const Passbook = withSuspendedCard(Passbook$, { loadingTitle: t.page.event.design.passbook.title });
